export default "https://cdn-static.gokick.com/assets/b11b69440b74c450e5ca5f7ba176f3cdc3a0fffe/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";